import { Component, OnInit } from '@angular/core';
import {
  MarketingPreferences,
  IStrapiDocument,
} from 'src/app/interfaces/strapi';

import { PageComponent } from 'src/app/shared/components/page/page.component';
import { Meta, Title } from '@angular/platform-browser';
import { UserService } from 'src/app/services/user.service';
import { UntypedFormBuilder, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { User } from 'src/app/shared/models/user.model';
import StrapiService from 'src/app/services/strapi.service';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { BreadcrumbsComponent } from '../../../shared/components/breadcrumbs/breadcrumbs.component';
import { RenderMarkdownComponent } from '../../../shared/components/render-markdown/render-markdown.component';
import { AuthService } from '../../../services/auth.service';

@Component({
    selector: 'app-marketing-preferences',
    templateUrl: './marketing-preferences.component.html',
    styleUrls: ['./marketing-preferences.component.scss'],
    imports: [
        BreadcrumbsComponent,
        RenderMarkdownComponent,
        NgIf,
        FormsModule,
        ReactiveFormsModule,
        RouterLink,
    ],
})
export class MarketingPreferencesComponent
  extends PageComponent
  implements OnInit
{
  public override pageData: MarketingPreferences = <MarketingPreferences>{};

  public prefsForm!: UntypedFormGroup;

  public updateError = false;

  public accepted!: boolean;

  constructor(
    public override readonly titleService: Title,
    public override readonly metaService: Meta,

    public override readonly strapi: StrapiService,
    public readonly formBuilder: UntypedFormBuilder,
    public readonly auth: AuthService,
    public readonly user: UserService
  ) {
    super(titleService, metaService, strapi);

    this.prefsForm = this.formBuilder.group({
      receiveEmails: [this.auth.currentUser?.acceptedEmail],
    });

    this.user.refreshUser().subscribe((res) => {
      this.auth.currentUser = res.data;

      this.prefsForm
        .get('receiveEmails')
        ?.setValue(this.auth.currentUser?.acceptedEmail);
    });
  }

  ngOnInit(): void {
    this.auth.redirectAfterLogin = null;

    this.accepted = this.prefsForm.get('receiveEmails')?.value;

    this.prefsForm
      .get('receiveEmails')
      ?.valueChanges.subscribe((rec: boolean) => {
        this.accepted = rec;
        const clone = User.fromJson(this.auth.currentUser!);
        clone.acceptedEmail = rec;
        clone.onboarded = true;

        this.user.updateUser(clone).subscribe({
          error: () => {
            this.updateError = true;
          },
        });
      });

    this.strapi
      .getDocumentsByType('marketing-preference')
      .subscribe((data: IStrapiDocument<MarketingPreferences>) => {
        this.parsePageData(data.data.attributes);
        super.setMetas();
      });
  }

  protected override parsePageData(page: MarketingPreferences): void {
    super.parsePageData(page);
    this.pageData = page;
  }

  public submit(e: Event): void {
    e.preventDefault();
  }
}
